import React, { FC } from 'react'
import { ComponentTiles } from '../../../models/components/tiles'
import { InnerTiles } from './subcomponent/innerTiles'

//* style
import GlobalContainer from '../globalContainer'
import { TilesContainer } from './style'

type Props = {
  data: ComponentTiles
}

const Tiles: FC<Props> = ({ data }) => {
  const tilesData = {
    numberOfColumns: data.numberOfColumns || 3,
    tiles: data.tiles || [],
    useCase: data.useCase || 'Icon',
    theme: data.theme || 'Grey',
    topPadding: data.topPadding || 'None',
    bottomPadding: data.bottomPadding || 'None',
  }

  return (
    <TilesContainer
      $topPadding={tilesData.topPadding}
      $bottomPadding={tilesData.bottomPadding}
      $theme={tilesData.theme}
      data-cy="Tiles">
      <GlobalContainer>
        <InnerTiles tilesData={tilesData} />
      </GlobalContainer>
    </TilesContainer>
  )
}

export default Tiles
